import { isEmpty, split, size, map } from "lodash"
import { Fragment } from "react"
import { createEscapedRegExp } from "helpers/string"

export function getHighlightedText(text, highlight) {
  if (isEmpty(text)) {
    return text
  }
  const regex = createEscapedRegExp(highlight)
  const matches = text.match(regex)

  if (isEmpty(matches)) {
    return text
  }

  // Split on the highlight regex to obtain the text parts around the matches
  const parts = split(text, regex)
  if (!size(parts)) {
    return text
  }

  // Combining all parts[i] + matches[i] results in the final, highlighted html
  return map(parts, (part, index) => <Fragment key={`part-${index}`}>
    {part}
    {matches[index] && <span className="highlight">{matches[index]}</span>}
  </Fragment>)
}

export const NON_SEARCHABLE_SECONDARY_TYPES = ["benchmark", "index", "portfolio", "experiment", "watchlist", "factor", "researchTopic"]
